export * from './dialogs';

import type { App } from 'vue';
import { default as DivisibleSection } from './components/DivisibleSection.vue';
import { default as ArticleReceiver } from './receivers/ArticleReceiver.vue';
import { default as CardReceiver } from './receivers/CardReceiver.vue';
import { default as DialogButtonReceiver } from './receivers/DialogButtonReceiver.vue';
import { default as NoReceiver } from './receivers/NoReceiver.vue';
import { default as PanelReceiver } from './receivers/PanelReceiver.vue';
import { default as SidebarButtonReceiver } from './receivers/SidebarButtonReceiver.vue';
import { default as SidebarReceiver } from './receivers/SidebarReceiver.vue';
import { default as RightpanelSectionReceiver } from './receivers/RightpanelSectionReceiver.vue';
import { default as LoadingPartial } from './partials/LoadingPartial.vue';
import { default as ErrorPartial } from './partials/ErrorPartial.vue';
import { default as ExamplePartial } from './partials/ExamplePartial.vue';
import { Divisible } from '@precon-tools-suite-by-shared/vue-divisibles';

export {
    useDivisible,
    useDivisibleReceiver,
    useDivisibleRemote,
    defaultDivisibleRemote,
    loading,
    type DivisibleReceiver,
    type DivisibleTarget,
    type DivisibleRemote,
    type DivisiblePart,
} from '@precon-tools-suite-by-shared/vue-divisibles';

export { useReceiverUserConfigStore } from './stores/receiverUserConfig';

import partialsPlugin, {
    type PluginOptions,
} from '@precon-tools-suite-by-shared/vue-partials';

export {
    Divisible,
    DivisibleSection,
    ArticleReceiver,
    CardReceiver,
    DialogButtonReceiver,
    NoReceiver,
    PanelReceiver,
    SidebarButtonReceiver,
    SidebarReceiver,
    RightpanelSectionReceiver,
    LoadingPartial,
    ExamplePartial,
    ErrorPartial,
};

export default {
    install(app: App, options: PluginOptions = {}) {
        // Partial plugin.
        app.use(partialsPlugin, {
            ...options,
            asyncComponentOptions: {
                loadingComponent: LoadingPartial,
                errorComponent: ErrorPartial,
                ...(options.asyncComponentOptions ?? {}),
            },
        });

        // Register divisibles.
        // eslint-disable-next-line vue/multi-word-component-names
        app.component('Divisible', Divisible);
        app.component('DivisibleSection', DivisibleSection);

        // Register receivers
        app.component('ArticleReceiver', ArticleReceiver);
        app.component('CardReceiver', CardReceiver);
        app.component('DialogButtonReceiver', DialogButtonReceiver);
        app.component('NoReceiver', NoReceiver);
        app.component('PanelReceiver', PanelReceiver);
        app.component('SidebarButtonReceiver', SidebarButtonReceiver);
        app.component('SidebarReceiver', SidebarReceiver);
        app.component('RightpanelSectionReceiver', RightpanelSectionReceiver);
    },
};
